/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RisksMetadata200Response
 */
export interface RisksMetadata200Response {
    /**
     * 
     * @type {Array<string>}
     * @memberof RisksMetadata200Response
     */
    sources?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RisksMetadata200Response
     */
    types?: Array<string>;
}

/**
 * Check if a given object implements the RisksMetadata200Response interface.
 */
export function instanceOfRisksMetadata200Response(value: object): value is RisksMetadata200Response {
    return true;
}

export function RisksMetadata200ResponseFromJSON(json: any): RisksMetadata200Response {
    return RisksMetadata200ResponseFromJSONTyped(json, false);
}

export function RisksMetadata200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RisksMetadata200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'sources': json['sources'] == null ? undefined : json['sources'],
        'types': json['types'] == null ? undefined : json['types'],
    };
}

  export function RisksMetadata200ResponseToJSON(json: any): RisksMetadata200Response {
      return RisksMetadata200ResponseToJSONTyped(json, false);
  }

  export function RisksMetadata200ResponseToJSONTyped(value?: RisksMetadata200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sources': value['sources'],
        'types': value['types'],
    };
}

